module.exports = __webpack_public_path__ + "media/images/default/lp_feature_2-f882c8f40bf3bccd712d60fc2fad143e.svg";